import React from "react";
import CommonTable, { HeadCell } from "src/business-types/grocery/components/CommonTable";
import { ConfigurationTableProps } from "../types";
import EditIcon from "@mui/icons-material/Edit";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { IconButton } from "@mui/material";

const ConfigTable: React.FC<ConfigurationTableProps> = ({ data, onEdit, onDelete }) => {
  const headCells: HeadCell<any>[] = [
    { id: "sno", label: "S.No", numeric: true },
    { id: "conname", label: "Configuration Name" },
    { id: "convalue", label: "Configuration Value", numeric: true },
    { id: "Actions", label: "Action" },
  ];

  const tableData = data.map((c, index) => ({
    id: c._id.$oid,
    sno: index +1,
    conname: c.conname,
    convalue: c.convalue,
    Actions: (
      <>
        <IconButton onClick={() => onEdit(c)}>
          <EditIcon sx={{ color: "black" }} />
        </IconButton>
        <IconButton onClick={() => onDelete(c)}>
          <DeleteOutlineIcon sx={{ color: "red" }} />
        </IconButton>
      </>
    ),
  }));

  return (
     <div className="w-full overflow-y-auto max-h-[60vh]">
      <CommonTable
        data={tableData}
        headCells={headCells}
        title="Configurations"
        selectable={false}
        pageSize={5}
        pagenation={true}
        denseToggle={false}
        showToolbar={false}
      />
    </div>
  );
};

export default ConfigTable;
